export interface AppEnvironment {
  production: boolean;
  name: string;
  default: string;
  features?: {
    [name: string]: boolean;
  };
  hosts: {
    [name: string]: AppHostConfig;
  };
  values: any;
}

export interface AppHostConfig {
  host?: string;
  protocol?: string;
  port?: string;
  root?: string;
  unauthenticated?: boolean;
  local?: boolean;
  endpoints: {
    [name: string]: string;
  };
}

export const environment: AppEnvironment = {
  production: false,
  name: 'common',
  default: 'preorders',
  values: {
    stripePublishKey: 'pk_test_72oeYDBeQR48ufUCSAmfLjVl005qHhCHd6',
    dwspayPublishKey: 'pk_test_51SypZwLiH39HtQeGC1EIthpNF5wdMqrNscLB4ncDNxaLIAjr9R6HczbVOUB77KmgVbBUFUmt6rIM4ZhxFjH5hOwz00ztCwp7tn',
    stripePaymentMethodConfiguration: 'pmc_1QmILXLCrn2DvYMpculFLE7w',
  },
  hosts: {
    preorders: {
      root: '/api/',
      endpoints: {
        'products': 'products',
        'products/types': 'products/types',
        'products/id': 'products/{id}',
        'preorders': 'preorders',
        'preorders/payment-intent': 'preorders/payment-intent',
        'contacts/email': 'contacts/{email}',
        'categories/wineryId': 'categories/{wineryId}',
        'addresses': 'addresses/{contactId}',
        'link/id/options': 'link/{id}/options',
        'link/id': 'link/{id}',
        'winery/wineryId': 'winery/{wineryId}',
        'coupon': 'coupon',
        'coupon/validate': 'coupon/validate',
        'coupon/consume': 'coupon/consume',
        'shipping/wineryId/calculate':'shipping/{wineryId}/calculate',
        //'shipping/wineryId/calculate-with-order/orderId':'shipping/{wineryId}/calculate-with-order/{orderId}',
        'shipping/wineryId/get-tax/countryCode':'shipping/{wineryId}/get-tax/{countryCode}',
        'shipping/wineryId/get-tax/countryCode/integrationId':'shipping/{wineryId}/get-tax/{countryCode}/integration/{integrationId}',
        'shipping/wineryId/get-shipment-partner/countryCode':'shipping/{wineryId}/get-shipment-partner/{countryCode}',
        'shipping/wineryId/do-order':'shipping/{wineryId}/do-order',
        'shipping/wineryId/get-enabled-countries':'shipping/{wineryId}/get-enabled-countries',
        'shipping/calculate-totals': 'shipping/calculate-totals'
      }
    },
    ws: {
      root: '/api/',
      endpoints: {
        'countries': 'countries',
      }
    },
    wspayments: {
      root: '/api/v1/wspayments/',
      endpoints: {
        'accounts/winery/dwspay': 'accounts/winery/{wineryId}/dwspay',
        'accounts/winery/payment-methods': 'accounts/winery/{wineryId}/payment-methods',
        'dwspay/payment-intent': 'dwspay/payment-intent', // Endpoint corretto nel backend
      }
    }
  }
};
